import { Field } from 'queries';
import { getFieldIndex } from './getFieldIndex';

export const getQuestionNumber = (fields: Field[], field: Field) => {
  return getFieldIndex(fields, field) + 1;
};
